import { useParams } from "react-router-dom";

export default function RecruitDetails() {
  const { id } = useParams();

  const recruiters = {
    1: { name: "Sanjay Kumar", company: "TechWorks", email: "sanjay@tech.com", phone: "9876543210" },
    2: { name: "Priya Verma", company: "HR Solutions", email: "priya@hr.com", phone: "9090909090" },
    3: { name: "Rajesh Gupta", company: "SkillHire", email: "raj@skill.com", phone: "9988776655" }
  };

  const rec = recruiters[id];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Recruiter Details</h1>

      <div className="bg-white p-6 rounded-xl shadow border w-96">
        <p><strong>Name:</strong> {rec.name}</p>
        <p><strong>Company:</strong> {rec.company}</p>
        <p><strong>Email:</strong> {rec.email}</p>
        <p><strong>Phone:</strong> {rec.phone}</p>
      </div>
    </div>
  );
}
